import { Component, inject } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AuthState } from '../../state/auth.state';
import { takeUntil } from 'rxjs/operators';
import { ChangePasswordDialogComponent } from '../password/reset-password-dialog/change-password-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginMethodType } from '../../state/auth.model';
import { LoggerService } from '../../../../modules/shared/services/logger.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { ShowHideDirective } from '@ngbracket/ngx-layout';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { LogoutComponent } from '../logout/logout.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-user-tools',
    templateUrl: './user-tools.component.html',
    styleUrls: ['./user-tools.component.scss'],
    imports: [
        MatButton,
        ShowHideDirective,
        MatTooltip,
        MatMenuTrigger,
        MatIcon,
        MatIconButton,
        MatMenu,
        MatMenuItem,
        LogoutComponent,
        AsyncPipe,
    ],
})
export class UserToolsComponent {
    isDefaultUser$: Observable<boolean> = inject(Store).select(AuthState.isDefaultUser);
    activeMethod$: Observable<LoginMethodType> = inject(Store).select(AuthState.activeMethod);

    username$ = new Subject<string>();
    showUsername$: Observable<boolean>;
    private dispose$ = new Subject<boolean>();

    constructor(private logger: LoggerService, private store: Store, private dialog: MatDialog) {}

    ngOnInit(): void {
        this.store
            .select(AuthState.user)
            .pipe(takeUntil(this.dispose$))
            .subscribe((user) => this.username$.next(user.username));
    }

    showResetForm() {
        this.dialog.open(ChangePasswordDialogComponent, { width: '420px' });
    }
}
